import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ErrorInfo } from '../models/notification.model';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService {
    private _defaultError: ErrorInfo = {
        errorCode: 404,
        errorTextOne: 'DEFAULT_ERROR_MSG_ONE',
        errorTextTwo: 'DEFAULT_ERROR_MSG_TWO'
    };

    private _errorSubject = new BehaviorSubject<ErrorInfo>(this._defaultError);
    errorObs$ = this._errorSubject.asObservable();

    private router = inject(Router);

    updateErrorMessage(errorInfo: ErrorInfo) {
        this._errorSubject.next(errorInfo);
    }

    handleInvalidCoin(invalidCoin: string) {
        const errorInfo: ErrorInfo = {
            errorCode: 404,
            errorTextOne: 'INVALID_COIN.HEADING',
            errorTextTwo: 'INVALID_COIN.MESSAGE',
            invalidCoin: invalidCoin
        };
        this._errorSubject.next(errorInfo);
        this.router.navigate(['/page-not-found']);
    }
}
